import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-icon-to-bill',
    templateUrl: './to-bill.component.svg',
    styleUrls: ['./to-bill.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToBillComponent {}
